export default "__VITE_ASSET__518cd096__"